module.exports = {
      id: "comm-vikatan-plus-usage",
      viewBox: "0 0 484.569 52.881",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#comm-vikatan-plus",
      toString: function () {
        return this.url;
      }
    }